// 『借入申込書』ボタン
import React from 'react';
import CenterButton from '../atoms/CenterButton';
import { loan_types,status_code_list } from '../Const';

interface Props {
  is_session_data_register?: boolean;
  status_code: number;
}

const ShowModernizationFundButton: React.FC<Props> = ({
  is_session_data_register,
  status_code,
}) => {
  // 近代化資金借入申込　確認に遷移する
  const handleClick = () => {
    /**
     * Note ：KWANKGM04290_近代化資金 確認(連帯債務者等)にて『同意書を表示する』ボタンの活性条件に本ボタンが押される事とあるが、
     * 本ボタン押下時は画面遷移してしまい押下したかの判定できないのでセッションを使用
     */
    is_session_data_register &&
      sessionStorage.setItem('item_id_33', loan_types.modernization_funds);

    // 現在のURLパラメータに近代化資金_借入申込の商品IDを追加
    const url = new URL(window.location.href);

    // パラメータが存在していない場合、パラメータ追加
    if (!url.searchParams.has('item_id')) {
      url.searchParams.append('item_id', '33');
    }
    if (!url.searchParams.has('is_confirmation') && status_code === status_code_list.borrowing_application_input) {
      url.searchParams.append('is_confirmation', 'true');
    }

    // 連帯債務者の場合、KWANKGM04310_近代化資金借入申込 確認(連帯債務者等) へ遷移
    // お申込人の場合、KWANKGM04270_近代化資金借入申込 確認 へ遷移
    window.location.href = url.href;
  };

  return (
    <div className="mt-5">
      <CenterButton label="借入申込書" btn_class="btn-base" handleClick={handleClick} />
    </div>
  );
};

export default ShowModernizationFundButton;
